export default "__VITE_ASSET__38160f65__"